<div class="button-wrapper-grid">
  <div class="cnt-extended-button" *ngFor="let activity of activityTypesArray; let i = index">
    <label
      class="cnt-button"
      [ngClass]="{ active: selected(activity.key) }"
      [title]="activity.key === 'ohv' ? 'OHV stands for Off-Highway Vehicle' : ''"
    >
      <input type="checkbox" [value]="activity.key" (change)="toggle(activity)" />
      <div *ngIf="activity.key !== activity.value" class="cnt-button-icon">
        <curbnturf-site-svgs [type]="activity.key" [white]="selected(activity.key)"> </curbnturf-site-svgs>
      </div>
      <div class="cnt-button-copy">{{ activity.value }}</div>
    </label>
    <ng-container *ngIf="showDescriptions">
      <a
        class="small"
        (click)="expand(i)"
        *ngIf="!expanded[i] && selected(activity.key) && description(activity.key) && !description(activity.key).value"
      >
        Add optional description...
      </a>
      <div *ngIf="expanded[i] || (description(activity.key) && description(activity.key).value)">
        <textarea class="semi-rounded" [formControl]="description(activity.key)"></textarea>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="showCustom">
    <div class="cnt-extended-button" *ngFor="let customType of customActivityTypes; let i = index">
      <label class="cnt-button" [ngClass]="{ active: selectedCustom(customType) }">
        <input type="checkbox" [value]="customType" (change)="toggleCustom(customType)" />
        <div class="cnt-button-copy">{{ customType }}</div>
      </label>

      <a
        class="small"
        (click)="expand(i + activityTypesArray.length)"
        *ngIf="!expanded[i + activityTypesArray.length] && selectedCustom(customType)"
      >
        Add optional description...
      </a>
      <div *ngIf="expanded[i + activityTypesArray.length] && descriptionCustom(customType)">
        <textarea class="semi-rounded" [formControl]="descriptionCustom(customType)"></textarea>
      </div>
    </div>

    <label class="cnt-button">
      <input
        type="text"
        class="cnt-button-copy custom-name"
        placeholder="Add Exclusive Activity"
        id="custom-onsite-name"
        name="custom-onsite-name"
        (change)="addCustom($event)"
      />
    </label>
  </ng-container>
</div>
